import Tipos from '@/services/tipos'

export default {
  async loadDataComercial({ commit }, payload) {
    try{
      const tipoService = new Tipos(payload.tipo)
      const tipoArr = await tipoService.getTipoByEmpresas(payload.empresas)
      commit('setTipos', tipoArr)
      commit('setTipo', payload.tipo)
      return Promise.resolve(tipoArr)
    } catch(error) {
      console.error(error);
      return Promise.reject(error)
    }
  }
}
